import {getEvent} from '../../../../../selectors/event'
import {isChooseSeatNoFee} from '../../../../../selectors/navigation'
import {DetailsPageAppProps} from '../../../../app/interfaces'
import {connect} from '../../../../runtime-context/context'
import {TicketFeesOwnProps, TicketFeesRuntimeProps} from './interfaces'
import {TicketFees as Presentation} from './ticket-fees'

const mapRuntime = ({state}: DetailsPageAppProps): TicketFeesRuntimeProps => ({
  event: getEvent(state),
  noServiceFee: isChooseSeatNoFee(state),
})

export const TicketFees = connect<TicketFeesOwnProps, TicketFeesRuntimeProps>(mapRuntime)(Presentation)
